import { toast } from "react-toastify";
import { endpoints,oids } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";

export async function GetQuestionnaireResponse({
  author,
  practitioner,
  hasProtocols = false,
  protocol,
  count_num = false,
  startDate,
  endDate,
}: any) {
  let baseUrl = `${endpoints.STATISTICS}/QuestionnaireResponse?&encounter.service-provider=Organization/${author}&questionnaire=Questionnaire/clinicalRegister&authored=ge${startDate}&authored=le${endDate}`;
  if (hasProtocols)
    baseUrl = `${baseUrl}&applied-protocol=QuestionnaireResponse/${protocol}`;
  if (practitioner != "all"){
    const practitioner_author = practitioner;
    baseUrl = `${baseUrl}&author=Practitioner/${oids.cpf}-${practitioner_author
              ?.split("-")
              .pop()}`
  }

  const bearerToken = await useAuth.getUserToken();
  const headers = {
    Accept: "application/fhir+json",
    Authorization: bearerToken,
    "Content-Type": "application/fhir+json",
  };
  // 1) Chamada de resumo para obter o total de entradas
  const summaryUrl = `${baseUrl}&_summary=count`;
  const summaryResponse = await useAxios
    .get(summaryUrl, { headers, timeout: 8000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`GetAdminQuestionnaireResponse Summary: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("GetAdminQuestionnaireResponse Summary ", error);
      throw new Error();
    });

  // Se count_num for verdadeiro, retorna apenas o resultado do summary
  if (count_num) return summaryResponse;

  const total = summaryResponse?.total;

  // 2) Chamada efetiva com _count=total (quando disponível)
  const effectiveUrl = Number.isFinite(total)
    ? `${baseUrl}&_count=${total}`
    : baseUrl;

  const fullResponse = await useAxios
    .get(effectiveUrl, { headers, timeout: 8000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`GetAdminQuestionnaireResponse: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("GetAdminQuestionnaireResponse ", error);
      // toast.error(
      //   `GetAdminQuestionnaireResponse Error: ${error?.response?.status}`
      // );
      throw new Error();
    });
  if (fullResponse) return fullResponse;
}
